import { c as _c } from "react/compiler-runtime";
import type { DocumentViewerCardContentKeyValueData } from '@onefootprint/request-types/dashboard';
import { Table } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useMobileLayout from '@/hooks/use-mobile-layout';
type KeyValueContentProps = {
  content: DocumentViewerCardContentKeyValueData;
};
type KeyValueEntry = {
  key: string;
  value: string;
};
const formatValue = (value: unknown): string => {
  if (value === null || value === undefined) {
    return '-';
  }
  if (typeof value === 'object') {
    return JSON.stringify(value);
  }
  return String(value);
};
const KeyValueContent = t0 => {
  const $ = _c(19);
  const {
    content
  } = t0;
  const {
    t
  } = useTranslation("document-viewer");
  const isMobile = useMobileLayout();
  let t1;
  if ($[0] !== content.data) {
    t1 = Object.entries(content.data).map(_temp);
    $[0] = content.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const entries = t1;
  if (entries.length === 0) {
    let t2;
    if ($[2] !== t) {
      t2 = t(_temp2);
      $[2] = t;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t2) {
      t3 = <p className="text-body-2 text-tertiary">{t2}</p>;
      $[4] = t2;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t2;
  if ($[6] !== isMobile || $[7] !== t) {
    t2 = isMobile ? [{
      text: t(_temp3)
    }] : [{
      text: t(_temp4),
      width: "40%"
    }, {
      text: t(_temp5),
      width: "60%"
    }];
    $[6] = isMobile;
    $[7] = t;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const columns = t2;
  let t3;
  if ($[9] !== t) {
    t3 = t(_temp6);
    $[9] = t;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== isMobile) {
    t4 = t5 => {
      const {
        item: item_0
      } = t5;
      return isMobile ? <td><div className="flex flex-col gap-0.5 py-2 whitespace-normal"><span className="text-caption-2 text-tertiary wrap-anywhere">{item_0.key}</span><span className="text-caption-2 text-primary wrap-anywhere">{item_0.value}</span></div></td> : <><td>{item_0.key}</td><td>{item_0.value}</td></>;
    };
    $[11] = isMobile;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== columns || $[14] !== entries || $[15] !== isMobile || $[16] !== t3 || $[17] !== t4) {
    t5 = <Table aria-label={t3} variant="compact" columns={columns} hideThead={isMobile} items={entries} getKeyForRow={_temp7} renderTr={t4} />;
    $[13] = columns;
    $[14] = entries;
    $[15] = isMobile;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
export default KeyValueContent;
function _temp(t0) {
  const [key, value] = t0;
  return {
    key,
    value: formatValue(value)
  };
}
function _temp2($) {
  return $.keyValue.noData;
}
function _temp3($_0) {
  return $_0.keyValue.keyColumn;
}
function _temp4($_1) {
  return $_1.keyValue.keyColumn;
}
function _temp5($_2) {
  return $_2.keyValue.valueColumn;
}
function _temp6($_3) {
  return $_3.keyValue.ariaLabel;
}
function _temp7(item) {
  return item.key;
}